import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { articleService } from '../services/api';
import ArticleCard from '../components/Articles/ArticleCard';

export default function CategoryPage() {
  const { slug } = useParams();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await articleService.getByCategory(slug, 30);
        setArticles(res.data);
      } catch (e) {
        setArticles([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [slug]);
  
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold capitalize mb-6">{slug}</h1>
      {articles.length === 0 ? (
        <p className="text-gray-600">No articles found.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map(a => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>
      )}
    </div>
  );
}
